<div class="container">
  <div class="header">
    <div class="header-content">
      <h2 class="header-title">Détail du périmètre {{ data?.selectedPopulation?.name }}</h2>
      <p class="header-subtitle">Visualisez les paramètres choisis</p>
    </div>
    <button class="close-button" (click)="onClose()" type="button" aria-label="Fermer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="divider horizontal"></div>

  <div class="body">
    <div class="section other-perimetre">
      <div class="perimetre">
        <p class="title">Postes</p>
        <div class="values">
          @for (poste of data?.populationFormations; track $index) {
            <div class="blue-pill">{{ poste.name }}</div>
          }
        </div>
      </div>

      <div class="perimetre">
        <p class="title">Statuts</p>
        <div class="values">
          @for (res of residency; track $index) {
            <div class="blue-pill">{{ res }}</div>
          }
        </div>
      </div>

      <div class="perimetre">
        <p class="title">Services</p>
        <div class="values">
          <div class="blue-pill">
            {{ service }}
          </div>
        </div>
      </div>
      <div class="divider horizontal"></div>

      <div class="perimetre">
        <p class="title">{{ data?.hospitalNames.roomsName }}s</p>
        <div class="values">
          @for (room of data?.populationRooms; track $index) {
            <div class="blue-pill">{{ data?.hospitalNames.roomsName }} {{ room.roomNumber }}</div>
          }
        </div>
      </div>
    </div>

    <div class="divider vertical"></div>

    <div class="perimetre-rh section">
      <p class="title">Périmètre RH</p>
      <div class="profiles">
        @for (profile of data?.populationProfiles; track $index) {
          <app-smart-op-avatar [profile]="profile"></app-smart-op-avatar>
          @if (!$last) {
            <div class="divider horizontal"></div>
          }
        }
      </div>
    </div>
  </div>

  <div class="divider horizontal"></div>

  <div class="footer">
    <app-button (click)="onClose()" text="Fermer"></app-button>
  </div>
</div>
